export const sortByField = (
  records: any[],
  field: string,
  direction: "ASC" | "DESC"
) => {
  const newRows = [...records];
  newRows.sort((a: any, b: any) => {
    const fields = field.split(".");

    const valueA = fields.reduce((acc, f) => acc[f], a);
    const valueB = fields.reduce((acc, f) => acc[f], b);
    if (valueA > valueB) {
      return -1;
    }
    if (valueB > valueA) {
      return 1;
    }
    return 0;
  });

  if (direction === "ASC") {
    newRows.reverse();
  }
  return newRows;
};

export const sort = (records: any[], direction: "ASC" | "DESC") => {
  const newRows = [...records];
  newRows.sort((a: any, b: any) => {
    if (a > b) {
      return -1;
    }
    if (b > a) {
      return 1;
    }
    return 0;
  });

  if (direction === "ASC") {
    newRows.reverse();
  }
  return newRows;
};

export const sortFn = (
  records: any[],
  getField: (record: any) => void,
  direction: "ASC" | "DESC"
) => {
  const newRows = [...records];
  newRows.sort((a: any, b: any) => {
    const valueA = getField(a);
    const valueB = getField(b);
    if (valueA > valueB) {
      return -1;
    }
    if (valueB > valueA) {
      return 1;
    }
    return 0;
  });

  if (direction === "ASC") {
    newRows.reverse();
  }
  return newRows;
};
